import React from 'react';
import {IScrollingFeaturedGenreGameContainer} from '@wearesection/bandai-react-components/organisms/ScrollingFeaturedGenreGameContainer';
import * as Types from 'graphql/types';
import {ComponentPropsAdapter} from '../../types';
import {convertPlatformToIcon, handleFilterTags, handleReturnSubtitleLanguage} from '~/utils';
import {GetRouter} from '~/utils';
import RenderNextImage from '../../atoms/render-next-image';
import {PLACEHOLDER_IMG} from '~/constants';
import dynamic from 'next/dynamic';
const ScrollingFeaturedGenreGameContainer = dynamic(
  () =>
    import('@wearesection/bandai-react-components/organisms/ScrollingFeaturedGenreGameContainer')
);
type FeaturedGenreGameContainer = Types.GamesListing &
  IScrollingFeaturedGenreGameContainer & {
    locale?: string;
  };

const adapter: ComponentPropsAdapter<
  FeaturedGenreGameContainer,
  IScrollingFeaturedGenreGameContainer
> = data => {
  const {pathname, locale} = GetRouter();

  return {
    title: data.title ?? '',
    description: data?.description ?? '',
    ticker:
      data?.ticker?.url ||
      'https://images.ctfassets.net/hnoi7ctzfs57/50en09t5fSAwIkLXULUaqM/d9b4e03cce26b7e2b87e6f4ff59d874c/Sticker.png',
    viewMore: {
      href: `/${locale}${data?.seeAllSlug}`,
      title: data?.seeAllText ?? '',
      target: data.openNewTab ? '_blank' : '_parent',
    },
    type: data.type,
    classSection: data.classSection ?? 'scrolling-featured-genre-game-container',
    listPopularCard:
      data?.listItemCollection?.items?.map(item => ({
        title: item?.title ?? '',
        linkHref: `/${locale}${pathname}/${item?.slug}` ?? '',
        mainImage: item?.mainThumbnailImg?.media?.url ?? PLACEHOLDER_IMG,
        mainImageNext: (
          <RenderNextImage
            src={item?.mainThumbnailImg?.media?.url ?? PLACEHOLDER_IMG}
            width={263}
            height={263}
            alt={item?.title || ''}
          />
        ),

        tags:
          handleFilterTags(item?.platform as [])?.map((item: any) => ({
            color: '#737373',
            title: React.createElement(convertPlatformToIcon(item)),
            disabled: false,
          })) || [],
        locale: handleReturnSubtitleLanguage(item?.subtitle || [], locale),
      })) ?? [],
  };
};

const ScrollingFeaturedGenreGameContainerOrganisms: React.FC<FeaturedGenreGameContainer> = (
  props: any
) => {
  const ComponentProps = adapter(props);

  return <ScrollingFeaturedGenreGameContainer {...ComponentProps} />;
};

export default ScrollingFeaturedGenreGameContainerOrganisms;
